module.exports = __webpack_public_path__ + "img/gb1235-76-30.prt.285e0034.jpg";